import React, { createContext, useContext, useReducer, Dispatch } from 'react';

interface EventState {
  currentEventTitle: string | null;
}

type EventAction = 
  | { type: 'SET_EVENT_TITLE'; payload: string }
  | { type: 'CLEAR_EVENT_TITLE' };

const EventContext = createContext<{
  state: EventState;
  dispatch: Dispatch<EventAction>;
}>({
  state: { currentEventTitle: null },
  dispatch: () => {},
});

const initialState: EventState = {
  currentEventTitle: null,
};

const eventReducer = (state: EventState, action: EventAction): EventState => {
  switch (action.type) {
    case 'SET_EVENT_TITLE':
      return {
        ...state,
        currentEventTitle: action.payload,
      };
    case 'CLEAR_EVENT_TITLE':
      return {
        ...state,
        currentEventTitle: null,
      };
    default:
      return state;
  }
};

export const EventContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(eventReducer, initialState);

  return (
    <EventContext.Provider value={{ state, dispatch }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventContext = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEventContext must be used within an EventContextProvider');
  }
  return context;
};

export default EventContext;
